import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrismComponent } from './prism.component';
export class PrismModule {
}
PrismModule.decorators = [
    { type: NgModule, args: [{
                declarations: [PrismComponent],
                exports: [PrismComponent],
                imports: [CommonModule]
            },] },
];
PrismModule.ctorParameters = () => [];
//# sourceMappingURL=prism.module.js.map